/**
 * @file index.tsx
 *
 * @fileoverview Renders job detail terms section.
 */

import { Maybe, Term } from '~/jobiqo/types/types';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Text } from '~/vcl/atoms/13-text/03-text';

interface JobDetailTermsSection {
  /**
   * Section title component.
   */
  Title: React.ReactNode;
  /**
   * Section's terms.
   */
  terms: Maybe<Term>[];
}

export const JobDetailTermsSection = ({
  Title,
  terms,
}: JobDetailTermsSection) => (
  <>
    <Text marginBottom={4} fontWeight={600}>
      {Title}
    </Text>
    <div className="jcl-list-styled">
      <ul>
        {terms.map((term, index) => term && <li key={index}>{term.label}</li>)}
      </ul>
    </div>
    <Spacing />
  </>
);

export default JobDetailTermsSection;
